import React, { ReactNode } from "react";
import { makeId } from "modules/forms/embedded/components/helpers";

type Props = {
    name: string;
    hidden: boolean;
    children: ReactNode;
}

export default function BlockWrapper(props: Props) {
    return (
        <div id={makeId(props.name)} hidden={props.hidden}>
            {props.children}
        </div>
    );
}